/**
 * AI Clinical Note Revision via Medplum Bot (`ai-clinical-note-revision`).
 */

import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier, QuestionnaireResponse } from '@medplum/fhirtypes';

export const AI_NOTE_REVISION_BOT_IDENTIFIER = {
  system: 'https://unify.health/bots',
  value: 'ai-clinical-note-revision',
} as const;

export function getAiNoteRevisionBotExecuteTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_AI_NOTE_REVISION_BOT_ID?.trim();
  if (id) return id;
  const system =
    import.meta.env.VITE_MEDPLUM_AI_NOTE_REVISION_BOT_IDENTIFIER_SYSTEM?.trim() ??
    AI_NOTE_REVISION_BOT_IDENTIFIER.system;
  const value =
    import.meta.env.VITE_MEDPLUM_AI_NOTE_REVISION_BOT_IDENTIFIER_VALUE?.trim() ??
    AI_NOTE_REVISION_BOT_IDENTIFIER.value;
  return { system, value };
}

export async function requestAiNoteRevision(
  medplum: MedplumClient,
  questionnaireResponseId: string,
  prompt: string,
): Promise<QuestionnaireResponse> {
  const result = await medplum.executeBot(
    getAiNoteRevisionBotExecuteTarget(),
    { questionnaireResponseId, prompt },
    ContentType.JSON,
  );
  if (!result || typeof result !== 'object' || (result as QuestionnaireResponse).resourceType !== 'QuestionnaireResponse') {
    throw new Error('AI revision bot did not return a QuestionnaireResponse');
  }
  return result as QuestionnaireResponse;
}
